<!--
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
-->
<template>
  <div class="contact-list">
    <ul>
      <li v-for="item in allMessagesList" class="contact-item" @click="selectMsgItem(item)" :class="{'active': item === activeMsgItem}" :key="item">
        <div class="syue-clr item-serial-number-box">
          <div class="syue-left">
            <span class="icon"></span>
            <span class="item-serial-number">{{item.acceptorId}}</span>
          </div>
          <div class="syue-right time">{{getLastSendTime(item)}}</div>
        </div>
        <div class="item-name" :class="{'show-unread-icon': item.unreadNum}">{{getCompanyName(item, '-')}}{{item.toName || '-'}} <span class="identity">({{getIdentity(item)}})</span></div>
        <div class="item-content">{{getLastMsg(item)}}</div>
      </li>
      
    </ul>
  </div>
</template>

<script >
  import mixin from './../mixin'

  // import Api from '../api'
  // import response from '../../../../utils/response/index.js'
  export default {
    mixins: [ mixin ],
    data () {
      return {
        list: []
      }
    },
    created () {
      // this.getList()
    },
    props: {
      allMessagesList: {
        type: Array
      },
      activeMsgItem: {
        type: Object
      }
    },
    computed: {
      // activeMsgItem: function () {
      //   return this.allMessagesList.find(item => {
      //     return item.applyFormCode === this.applyFormCode && item.clientType === this.clientType && item.acceptorId === this.acceptorId && item.toId === this.toId
      //   }) || {}
      // }
    },
    methods: {
      getLastMsg (msgItem) {
        if (msgItem.msgList.length > 0) {
          const msg = msgItem.msgList[msgItem.msgList.length - 1]
          return parseInt(msg.msgType) === 2 ? '[文件]' : msg.msgBody
        } else {
          return msgItem.lastMsg.lastSendMessage || '-'
        }
      },
      getLastSendTime (msgItem) {
        if (msgItem.msgList.length > 0) {
          const msg = msgItem.msgList[msgItem.msgList.length - 1]
          return msg.showTime.split(' ')[0]
        } else {
          return this.handleTime(msgItem.lastMsg.sendTime, '', 'MM-DD') || '-'
        }
      },
      selectMsgItem (item) {
        if (item === this.activeMsgItem) {
          return true
        }
        this.$emit('selectMsgItem', item)
      }
    //   async getList () {
    //     const api = Api.selectUserGroupList
    //     const res = await response(this.$http(api.type, api.url, {
    //       clientType: 'purchaser'
    //     }))
    //     if (res.isOk) {
    //       this.list = res.content
    //     }
    //   }
    }
  }
</script>

<style lang="scss" scoped>
.contact-list{
  background: #fff;
  .contact-item {
    padding: 12px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    &.active{
      background: #EFF0F1;
      cursor: default;
    }
    &:hover{
      background: #EFF0F1;
    }
    .item-serial-number-box{
      margin-bottom: 6px;
    }
    .identity{
      color: #909090;
    }
    .item-serial-number{
      line-height: 20px;
      font-size: 14px;
      color:#303030;
      // margin-bottom: 6px;
    }
    .item-name{
      font-size: 12px;
      color: #303030;
      line-height: 16px;
      margin-bottom: 4px;
      position: relative;
      &.show-unread-icon{
        &:after{
          width: 8px;
          height: 8px;
          background: #e60d0B;
          border-radius: 4px;
          top: 50%;
          margin-top: -4px;
          content: '\20';
          position: absolute;
          right: 0px;
        }
      }
    }
    .item-content{
      line-height: 16px;
      color: #909090;
      font-size: 12px;
      height: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis; 
    }
    .time{
      color:#909090; 
      font-size: 12px;
    }
  }
}
</style>